import { HttpError } from "@nestia/fetcher";
import api from "@api";
import { getConnection } from "@app/sdk";

import { PageOfPreorder } from "@api/structures/PageOfPreorder";

export interface Filters {
  isConfirmed?: boolean;
  isResolved?: boolean;
  pageSize: number;
  page: number;
}

const defaultResponse: PageOfPreorder = { rows: [], totalPages: 0 };

export const getAllOrders = async (
  filters: Filters,
): Promise<PageOfPreorder> => {
  try {
    const response = await api.functional.orders.getPreorders(
      getConnection(),
      filters,
    );
    return response?.responseObject ?? defaultResponse;
  } catch (e) {
    if (e instanceof HttpError) {
      return defaultResponse;
    }
    throw e;
  }
};

export const getPendingOrders = async (filters: Filters) => {
  try {
    const response = await api.functional.orders.pending.getPending(
      getConnection(),
      filters,
    );
    return response?.responseObject ?? defaultResponse;
  } catch (e) {
    if (e instanceof HttpError) {
      return defaultResponse;
    }
    throw e;
  }
};
